export const FILTER_ACTIONS = {
	SET_MARKETS: 'markets',
	SET_PRODUCTS: 'products',
	SET_REASONS: 'reasons',
	RESET: 'reset',
};

export const DEFAULT_FILTER = {
	markets: [],
	products: [],
	reasons: [],
};
